import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { MyOrdersInsurance } from 'shared/api/avia/insurance'
import { copyText } from 'shared/lib/copyText'
import { previewPdfUrl } from 'shared/lib/pdf-preview'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface Props {
  insurance: MyOrdersInsurance
}

export const InsuranceInfoCard = ({ insurance }: Props) => {
  const { t } = useTranslation()

  const onShowInsurance = () => {
    previewPdfUrl(insurance.policy.url)
  }

  const onCopyInsuranceNum = () => {
    copyText(insurance.policy.number)
  }
  return (
    <div className={s.insuranceListCard}>
      <p className={clsx('medium-15', s.listCardTitle)}>
        {insurance.service_info.description}
      </p>

      <div className={s.insuranceNumber}>
        <div className={s.insuranceNumberCol}>
          <p className={clsx('regular-12', s.numberTitle)}>
            {t('insurance_info.number_insurance')}
          </p>
          <p className={clsx('regular-14', s.number)}>
            {insurance.policy.number}
          </p>
        </div>

        <AppIcon
          id={AllIcons.COPY}
          className={s.copy}
          onClick={onCopyInsuranceNum}
        />
      </div>

      <p
        className={clsx(s.insuranceBtn, 'medium-14')}
        onClick={onShowInsurance}
      >
        {t('insurance_info.view_insurance')}
      </p>
    </div>
  )
}
